import React, { PropsWithChildren } from 'react'
import { tableColumnTypes } from '../../../Component/EnhancedData/SortableTable/TableBody'
import { ColumnDataTypeConfiguration } from '../../../Component/EnhancedData/SortableTable/Types'
import * as EDT from '../../../Type/EnhancedData'

interface SummaryItem {
  key: string
  label: string;
  value?: number | string;
  dataType?: ColumnDataTypeConfiguration
}

interface SummaryProps {
  transactionDetail?: EDT.TransactionSearchRecordForManualFill
}

const mapToSummaryItems = (transactionDetail?: EDT.TransactionSearchRecordForManualFill): SummaryItem[] => {
  return [
    {
      key: 'transaction_id',
      label: 'Transaction ID',
      value: transactionDetail?.legacy_record_id || '',
    },
    {
      key: 'invoice_number',
      label: 'Invoice ID',
      value: transactionDetail?.invoice_number || '',
    },
    {
      key: 'billing_name',
      label: 'Billing Name',
      value: transactionDetail?.billing_name || '',
    },
    {
      key: 'settle_amount',
      label: 'Amount',
      value: transactionDetail?.settle_amount,
      dataType: tableColumnTypes.money,
    },
  ]
}

export function TransactionSummarySection ({ transactionDetail, children }: PropsWithChildren<SummaryProps>): React.JSX.Element {
  const summaryItems: SummaryItem[] = mapToSummaryItems(transactionDetail)
  return (
        <table className="transaction-summary">
            <tbody>
              {
                summaryItems.map((item) => {
                  const displayValue = item.dataType?.formatter ? item.dataType.formatter(item?.value) : item?.value
                  return (
                    <tr key={item.key} className="transaction-summary-row">
                      <td className="transaction-summary-cell"><strong>{item.label}</strong></td>
                      <td className="transaction-summary-cell">{displayValue || ''}</td>
                    </tr>
                  )
                })
              }
              {children}
            </tbody>
        </table>
  )
}
